import { Injectable } from '@angular/core';
import { ConfigurationModule } from '../../../configuration.module';
import { EndSessionConfiguration } from './end-session-configuration';

@Injectable({
  providedIn: ConfigurationModule
})
export class EndSessionConfigurationService {

  configuration: EndSessionConfiguration;

  constructor() { }

  loadConfiguration(configuration) {
    configuration.enabled=true;
    this.configuration = configuration;
  }
}
